import {Api, apiUrls} from "../../helpers/api";
import http from "../../common/services/httpService";
import {AxiosResponse} from "axios";
import {AssignOwnVehicleModel, OwnVehicleAssignmentModel} from "../models/vehicleAssigment";
import { HttpErrorModel } from "../../common/models/httpError";


export class VehicleAssigmentService {
    private static baseUrl = `${apiUrls.administration.users}/vehicle-assignment`;

    public static async getOwnVehicleAssignment(): Promise<AxiosResponse<OwnVehicleAssignmentModel>> {
        return await http.get<OwnVehicleAssignmentModel>(`${Api.getUrl(this.baseUrl)}/current`);
    }

    public static async assignOwnVehicle(data: AssignOwnVehicleModel): Promise<AxiosResponse<HttpErrorModel[] | any>> {
        return await http.post(`${Api.getUrl(this.baseUrl)}/assign`, data);
    }

    public static async unassignOwnVehicle(): Promise<AxiosResponse<HttpErrorModel[] | any>> {
        return await http.post(`${Api.getUrl(this.baseUrl)}/unassign`);
    }
}
